/* eslint-disable max-len */
import { useLanguageValue } from '@ipc/ipc-core';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { messages } from '../../locales/locales';
import NotificationsContainer from '../common/NotificationsContainer';
import './appContainer.scss';
import AppContent from './AppContent';
import AppFooter from './AppFooter';
import AppHeader from './header/AppHeader';

export const AppContainerComponent = () => {
  const [{ currentLanguage }] = useLanguageValue();
  return (
    <IntlProvider locale={currentLanguage} messages={messages[currentLanguage]}>
      <div className="appContainer">
        <NotificationsContainer />
        <AppHeader />
        <AppContent />
        <AppFooter />
      </div>
    </IntlProvider>
  );
};

export default AppContainerComponent;
